import React, { useState } from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import SubCategories from "./SubCategories";
import ParentCategories from "./ParentCategories";

const CategoriesTab = ({ userInfoData }) => {
  const [selectedTab, setSelectedTab] = useState(0);

  const handleTabSelect = (index) => {
    setSelectedTab(index);
  };

  return (
    <div className="blog-form-tabs-container mt30">
      <Tabs selectedIndex={selectedTab} onSelect={handleTabSelect}>
        <TabList>
          <Tab>parent categories</Tab>
          <Tab>sub categories</Tab>
        </TabList>

        <TabPanel>
          <ParentCategories userInfoData={userInfoData} />
        </TabPanel>

        <TabPanel>
          <SubCategories userInfoData={userInfoData} />
        </TabPanel>
      </Tabs>
    </div>
  );
};

export default CategoriesTab;
